import Vue from 'vue';
export default Vue.extend({
    props: {
        currentColumn: {
            type: [Number, undefined],
            default: undefined
        },
        currentHintColumn: {
            type: [Number, undefined],
            default: undefined
        },
        graphDataSummary: {
            type: Object
        },
        previousLabel: {
            type: [String, undefined],
            default: undefined
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        showHints: {
            type: Boolean,
            default: false
        },
        xAxisData: {
            type: Object,
            required: true
        }
    },
    computed: {
        columnErrorValues() {
            return this.showErrors
                ? Object.keys(this.graphDataSummary).reduce((agg, key) => {
                    if (!this.graphDataSummary[key].currentAnswer &&
                        this.graphDataSummary[key].currentAnswer !== this.graphDataSummary[key].correctAnswer) {
                        agg.push(0);
                    }
                    if (this.graphDataSummary[key].currentAnswer &&
                        this.graphDataSummary[key].currentAnswer !== this.graphDataSummary[key].correctAnswer) {
                        agg.push(this.graphDataSummary[key].currentAnswer);
                    }
                    return agg;
                }, [])
                : [];
        }
    },
    data() {
        return {
            columns: new Array(this.xAxisData.maxValue / this.xAxisData.increment),
            columnWidth: `${100 / (this.xAxisData.maxValue / this.xAxisData.increment)}%`
        };
    },
    methods: {
        hasCurrentBorderClass(columnIndex) {
            return !!(typeof this.currentColumn !== 'undefined' &&
                this.currentColumn / this.xAxisData.increment - 1 === columnIndex);
        },
        hasHintBorderClass(columnIndex) {
            return (typeof this.previousLabel !== 'undefined' &&
                this.currentHintColumn === this.xAxisData.increment * (columnIndex + 1));
        },
        hasRootBorderClass(columnIndex) {
            return (!columnIndex &&
                typeof this.currentColumn === 'undefined' &&
                this.columnErrorValues.includes(0));
        },
        hasErrorBorderClass(columnIndex) {
            return ((!columnIndex &&
                typeof this.currentColumn === 'undefined' &&
                this.columnErrorValues.includes(this.xAxisData.increment * (columnIndex + 1))) ||
                (columnIndex &&
                    typeof this.currentColumn === 'undefined' &&
                    this.columnErrorValues.includes(this.xAxisData.increment * (columnIndex + 1))));
        },
        hasCurrentLabelClass(columnIndex, isLastColumn = false) {
            return isLastColumn
                ? typeof this.currentColumn !== 'undefined' &&
                    this.currentColumn === columnIndex * this.xAxisData.increment + this.xAxisData.increment
                : !!this.currentColumn && this.currentColumn / this.xAxisData.increment === columnIndex;
        },
        hasHintLabelClass(columnIndex, isLastColumn) {
            return (typeof this.currentColumn !== 'undefined' &&
                (isLastColumn
                    ? this.currentHintColumn ===
                        columnIndex * this.xAxisData.increment + this.xAxisData.increment
                    : this.currentHintColumn === this.xAxisData.increment * columnIndex));
        },
        hasErrorLabelClass(columnIndex, isLastColumn = false) {
            return isLastColumn
                ? typeof this.currentColumn === 'undefined' &&
                    this.columnErrorValues.includes(columnIndex * this.xAxisData.increment + this.xAxisData.increment)
                : typeof this.currentColumn === 'undefined' &&
                    this.columnErrorValues.includes(this.xAxisData.increment * columnIndex);
        },
        hasLastEvenLabel(columnIndex) {
            return (columnIndex * this.xAxisData.increment + this.xAxisData.increment) % 2 === 1;
        },
        hasLastOddLabel(columnIndex) {
            return (columnIndex * this.xAxisData.increment + this.xAxisData.increment) % 2 === 0;
        }
    }
});
